module.exports = __webpack_public_path__ + "img/kemanStore-appkey.5adf36b6.png";